export const createH1 = (str) => `# ${str}`;
export const createH3 = (str) => `### ${str}`;
